unit View.Facil_Planos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewFacil_PlanosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbgrade_nome: TLabel;
    edgrade_nome: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFacil_PlanosGet: TXDataWebClient;
    XDataClientFacil_PlanosDelete: TXDataWebClient;
    Facil_PlanosDataset: TXDataWebDataSet;
    Facil_PlanosDatasetid: TIntegerField;
    Facil_PlanosDatasetgrade_nome: TStringField;
    Facil_PlanosDatasetnome: TStringField;
    Facil_PlanosDatasetcodigo_interno: TIntegerField;
    Facil_PlanosDatasetexcluido: TBooleanField;
    Facil_PlanosDatasetinclusao: TDateTimeField;
    Facil_PlanosDatasetalteracao: TDateTimeField;
    Facil_PlanosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientFacil_PlanosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientFacil_PlanosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientFacil_PlanosDeleteError(Error: TXDataClientError);
    procedure Facil_PlanosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFacil_PlanosEdit: TFViewFacil_PlanosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFacil_PlanosEdit }

procedure TFViewFacil_PlanosEdit.btSaveClick(Sender: TObject);
begin
  if Facil_PlanosDataset.State in dsEditModes then
  begin
        Facil_PlanosDataset.Post;
    Facil_PlanosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewFacil_PlanosEdit.btDeleteClick(Sender: TObject);
begin
  if Facil_PlanosDataset.State in dsEditModes then
    Facil_PlanosDataset.Post;
  XDataClientFacil_PlanosDelete.Delete(Facil_PlanosDataset.EntitySetName,
    TJSObject(Facil_PlanosDataset.CurrentData));
end;


class function TFViewFacil_PlanosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFacil_PlanosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewFacil_PlanosEdit.InsertEntity;
begin
  Facil_PlanosDataset.Close;
  Facil_PlanosDataset.SetJsonData('{}');
  Facil_PlanosDataset.Open;
  Facil_PlanosDataset.Insert;
end;

class function TFViewFacil_PlanosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFacil_PlanosEdit(AForm).FInserting := AInserting;
    TFViewFacil_PlanosEdit(AForm).FId := AId;
    TFViewFacil_PlanosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFacil_PlanosEdit(AForm).InsertEntity
    else
      TFViewFacil_PlanosEdit(AForm).LoadEntity;
    TFViewFacil_PlanosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewFacil_PlanosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFacil_PlanosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Facil_PlanosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Facil_PlanosDataset.EntitySetName
    )
  );
  XDataClientFacil_PlanosGet.Get(Facil_PlanosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewFacil_PlanosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewFacil_PlanosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewFacil_PlanosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewFacil_PlanosEdit.XDataClientFacil_PlanosGetLoad(Response: TXDataClientResponse);
begin
  Facil_PlanosDataset.Close;
  Facil_PlanosDataset.SetJsonData(Response.Result);
  Facil_PlanosDataset.Open;
  
  Facil_PlanosDataset.Edit;  
end;

procedure TFViewFacil_PlanosEdit.XDataClientFacil_PlanosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewFacil_PlanosEdit.XDataClientFacil_PlanosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewFacil_PlanosEdit.Facil_PlanosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewFacil_PlanosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFacil_PlanosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.facil_planos.form.message');
  lbMessage := TLabel.Create('view.facil_planos.form.message.label');
  btCloseMessage := TButton.Create('view.facil_planos.form.message.button');
  btCancel := TButton.Create('view.facil_planos.form.btBack');
  btSave := TButton.Create('view.facil_planos.form.btSave');
  btDelete := TButton.Create('view.facil_planos.form.btDelete');
  lbid := TLabel.Create('view.facil_planos.form.lbid');
  edid := TDBEdit.Create('view.facil_planos.form.edid');
  lbgrade_nome := TLabel.Create('view.facil_planos.form.lbgrade_nome');
  edgrade_nome := TDBEdit.Create('view.facil_planos.form.edgrade_nome');
  lbnome := TLabel.Create('view.facil_planos.form.lbnome');
  ednome := TDBEdit.Create('view.facil_planos.form.ednome');
  lbcodigo_interno := TLabel.Create('view.facil_planos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.facil_planos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.facil_planos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.facil_planos.form.edexcluido');
  lbinclusao := TLabel.Create('view.facil_planos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.facil_planos.form.edinclusao');
  lbalteracao := TLabel.Create('view.facil_planos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.facil_planos.form.edalteracao');
  lbexclusao := TLabel.Create('view.facil_planos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.facil_planos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Facil_PlanosDataset := TXDataWebDataSet.Create(Self);
  Facil_PlanosDatasetid := TIntegerField.Create(Self);
  Facil_PlanosDatasetgrade_nome := TStringField.Create(Self);
  Facil_PlanosDatasetnome := TStringField.Create(Self);
  Facil_PlanosDatasetcodigo_interno := TIntegerField.Create(Self);
  Facil_PlanosDatasetexcluido := TBooleanField.Create(Self);
  Facil_PlanosDatasetinclusao := TDateTimeField.Create(Self);
  Facil_PlanosDatasetalteracao := TDateTimeField.Create(Self);
  Facil_PlanosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientFacil_PlanosGet := TXDataWebClient.Create(Self);
  XDataClientFacil_PlanosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbgrade_nome.BeforeLoadDFMValues;
  edgrade_nome.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Facil_PlanosDataset.BeforeLoadDFMValues;
  Facil_PlanosDatasetid.BeforeLoadDFMValues;
  Facil_PlanosDatasetgrade_nome.BeforeLoadDFMValues;
  Facil_PlanosDatasetnome.BeforeLoadDFMValues;
  Facil_PlanosDatasetcodigo_interno.BeforeLoadDFMValues;
  Facil_PlanosDatasetexcluido.BeforeLoadDFMValues;
  Facil_PlanosDatasetinclusao.BeforeLoadDFMValues;
  Facil_PlanosDatasetalteracao.BeforeLoadDFMValues;
  Facil_PlanosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientFacil_PlanosGet.BeforeLoadDFMValues;
  XDataClientFacil_PlanosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewFacil_PlanosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 481;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 421;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 421;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 421;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbgrade_nome.SetParentComponent(Self);
    lbgrade_nome.Name := 'lbgrade_nome';
    lbgrade_nome.Left := 24;
    lbgrade_nome.Top := 219;
    lbgrade_nome.Width := 14;
    lbgrade_nome.Height := 13;
    lbgrade_nome.Caption := 'grade_nome:';
    lbgrade_nome.Transparent := True;
    edgrade_nome.SetParentComponent(Self);
    edgrade_nome.Name := 'edgrade_nome';
    edgrade_nome.Left := 221;
    edgrade_nome.Top := 216;
    edgrade_nome.Width := 200;
    edgrade_nome.Height := 21;
    edgrade_nome.Enabled := True;
    edgrade_nome.TabOrder := 7;
    edgrade_nome.Text := 'edgrade_nome';
    edgrade_nome.DataField := 'grade_nome';
    edgrade_nome.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 246;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 243;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 8;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 273;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 270;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 9;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 300;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 297;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 10;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 327;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 324;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 11;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 354;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 351;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 12;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 381;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 378;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 13;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Facil_PlanosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Facil_PlanosDataset.SetParentComponent(Self);
    Facil_PlanosDataset.Name := 'Facil_PlanosDataset';
    Facil_PlanosDataset.AfterApplyUpdates := Facil_PlanosDatasetAfterApplyUpdates;
    Facil_PlanosDataset.EntitySetName := 'Facil_Planos';
    Facil_PlanosDataset.Connection := DMConnection.ApiConnection;
    Facil_PlanosDataset.Left := 176;
    Facil_PlanosDataset.Top := 8;
    Facil_PlanosDatasetid.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetid.Name := 'Facil_PlanosDatasetid';
    Facil_PlanosDatasetid.FieldName := 'id';
    Facil_PlanosDatasetid.Required := True;
    Facil_PlanosDatasetgrade_nome.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetgrade_nome.Name := 'Facil_PlanosDatasetgrade_nome';
    Facil_PlanosDatasetgrade_nome.FieldName := 'grade_nome';
    Facil_PlanosDatasetgrade_nome.Required := False;
    Facil_PlanosDatasetgrade_nome.Size := 255;
    Facil_PlanosDatasetnome.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetnome.Name := 'Facil_PlanosDatasetnome';
    Facil_PlanosDatasetnome.FieldName := 'nome';
    Facil_PlanosDatasetnome.Required := True;
    Facil_PlanosDatasetnome.Size := 255;
    Facil_PlanosDatasetcodigo_interno.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetcodigo_interno.Name := 'Facil_PlanosDatasetcodigo_interno';
    Facil_PlanosDatasetcodigo_interno.FieldName := 'codigo_interno';
    Facil_PlanosDatasetcodigo_interno.Required := True;
    Facil_PlanosDatasetexcluido.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetexcluido.Name := 'Facil_PlanosDatasetexcluido';
    Facil_PlanosDatasetexcluido.FieldName := 'excluido';
    Facil_PlanosDatasetexcluido.Required := False;
    Facil_PlanosDatasetinclusao.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetinclusao.Name := 'Facil_PlanosDatasetinclusao';
    Facil_PlanosDatasetinclusao.FieldName := 'inclusao';
    Facil_PlanosDatasetinclusao.Required := False;
    Facil_PlanosDatasetalteracao.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetalteracao.Name := 'Facil_PlanosDatasetalteracao';
    Facil_PlanosDatasetalteracao.FieldName := 'alteracao';
    Facil_PlanosDatasetalteracao.Required := False;
    Facil_PlanosDatasetexclusao.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetexclusao.Name := 'Facil_PlanosDatasetexclusao';
    Facil_PlanosDatasetexclusao.FieldName := 'exclusao';
    Facil_PlanosDatasetexclusao.Required := False;
    XDataClientFacil_PlanosGet.SetParentComponent(Self);
    XDataClientFacil_PlanosGet.Name := 'XDataClientFacil_PlanosGet';
    XDataClientFacil_PlanosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFacil_PlanosGet, Self, 'OnLoad', 'XDataClientFacil_PlanosGetLoad');
    XDataClientFacil_PlanosGet.Left := 64;
    XDataClientFacil_PlanosGet.Top := 8;
    XDataClientFacil_PlanosDelete.SetParentComponent(Self);
    XDataClientFacil_PlanosDelete.Name := 'XDataClientFacil_PlanosDelete';
    XDataClientFacil_PlanosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFacil_PlanosDelete, Self, 'OnLoad', 'XDataClientFacil_PlanosDeleteLoad');
    SetEvent(XDataClientFacil_PlanosDelete, Self, 'OnError', 'XDataClientFacil_PlanosDeleteError');
    XDataClientFacil_PlanosDelete.Left := 64;
    XDataClientFacil_PlanosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbgrade_nome.AfterLoadDFMValues;
    edgrade_nome.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Facil_PlanosDataset.AfterLoadDFMValues;
    Facil_PlanosDatasetid.AfterLoadDFMValues;
    Facil_PlanosDatasetgrade_nome.AfterLoadDFMValues;
    Facil_PlanosDatasetnome.AfterLoadDFMValues;
    Facil_PlanosDatasetcodigo_interno.AfterLoadDFMValues;
    Facil_PlanosDatasetexcluido.AfterLoadDFMValues;
    Facil_PlanosDatasetinclusao.AfterLoadDFMValues;
    Facil_PlanosDatasetalteracao.AfterLoadDFMValues;
    Facil_PlanosDatasetexclusao.AfterLoadDFMValues;
    XDataClientFacil_PlanosGet.AfterLoadDFMValues;
    XDataClientFacil_PlanosDelete.AfterLoadDFMValues;
  end;
end;

end.
